const module = { name: 'movie/shared/desktop/rottenTomatoes', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_movieDetails_context } from 'require-core';

const { movieDetails, context: { req: { route }, featureFlags } } = Fandango_movieDetails_context;


import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { Fandango_eventQueue as eventQueue } from 'require-global';



const { EventNames } = eventQueue


const Selectors = {
    CONTAINER: '.js-rotten-tomatoes'
}


const ICON_PREFIX = 'icon-rottom-flat-'


const RouteNames = Object.freeze({
    MOVIE_REVIEWS: 'reviews'
})


const ReviewsTypes = {
    CRITIC: 'critic',
    MOVIE: 'movie',
}
function onDone(result) {
    if (!result || !result.data) {
        return;
    }
    const data = result.data;
    const { id, sluggedTitle } = movieDetails;
    const viewModel = {
        criticsURL: links.reviews({ title: sluggedTitle, id, reviewsType: ReviewsTypes.CRITIC }),
        criticsScore: data.criticsScore,
        iconClassCritics: ICON_PREFIX + data.criticsRating,
        audienceURL: links.reviews({ title: sluggedTitle, id, reviewsType: ReviewsTypes.MOVIE }),
        audienceScore: data.audienceScore,
        iconClassAudience: ICON_PREFIX + data.audienceRating
    };
    const markup = swig.render('_rottenTomatoesRating', viewModel);
    document.querySelector(Selectors.CONTAINER).innerHTML = markup;
}
function onFail(err) {
    debugLog.warn(module.name, 'Fan Reviews API Fail', err);
}
function init() {
    if (!featureFlags.rottenTomatoesIntlEnabled) {
        return;
    }
    const container = document.querySelector(Selectors.CONTAINER);
    if (!container) {
        return;
    }
    const movie = movieDetails;
    if (!movie || !movie.id) {
        return;
    }
    if (route !== RouteNames.MOVIE_REVIEWS) {
        xhr.ajax({
            method: 'GET',
            url: links.napiFanAndCriticReviews({
                id: movie.id,
                pageSize: 1
            }),
        })
            .done(onDone)
            .fail(onFail);
    }
    else {
        eventQueue.on(EventNames.MOP_FAN_CRITIC_REVIEWS_API, onDone);
    }
}
module.exports = {
    init,
};
export default module.exports;